import Modal from "@mui/material/Modal";
import {Slide} from "@mui/material";
import SystemBottomSheetClosingIcon from "../../../components/icons/SystemBottomSheetClosingIcon";
import {ClosingIconSize} from "../../../controllers/SystemBottomSheetClosingIconController";
import ExerciserCorrectionContent from "../../../components/others/courses/exercisers/ExerciserCorrectionContent";
import SystemCorrectionGhostTopBar from "../../../components/bars/SystemCorrectionGhostTopBar";

export default function ExerciserCorrectionScreen({open, handleClose, question}) {
    // Used in FlashResultsQuestionItem component to show single question
    // correction

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}
               disableEnforceFocus>
            <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                <div className="overflow-auto w-full h-[100svh] flex flex-col items-center justify-end outline-none">
                    <SystemCorrectionGhostTopBar handleClose={handleClose} />
                    <div className={"relative overflow-auto w-full grow flex flex-col items-center rounded-t-[32px]"}>
                        <SystemBottomSheetClosingIcon onPressed={handleClose}
                                                      closingIconSize={ClosingIconSize.MEDIUM} />
                        <ExerciserCorrectionContent question={question} />
                    </div>
                </div>
            </Slide>
        </Modal>
    );
}